export default "__VITE_ASSET__a9ec7c8b__"